import {Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {UtilsService} from '../../../../core/utils/utils.service';
import {Subscription} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {PrintMenuService} from '../../../../core/services/gestionmenus/print-menu.service';
import {
  PreparationConditionnementService
} from "../../../../core/services/conditionnements/preparation-conditionnement.service";
import {PRINT_MODE} from "../../../../core/constants";
import BonLivraisonSettingsMl from "../../../../core/dtos/conditionnement/bon-livraison-settings-ml";
import {DxDateRangeBoxComponent} from "devextreme-angular";
import {ButtonThemeEnum} from '../../../../shared/ui/button/button-theme-enum';

@Component({
    selector: 'yo-bon-livraison',
    templateUrl: './bon-livraison.component.html',
    styleUrls: ['./bon-livraison.component.scss'],
    standalone: false
})
export class BonLivraisonComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  @Output() loadingChange = new EventEmitter<{ visible: boolean; message: string }>();
  public planProductionIdList: number[] = [];
  public planProductionDetailIdList: number[] = [];
  @ViewChild('selectedDates') selectedDates: DxDateRangeBoxComponent;
  comment: string;
  message: string;
  displayDialog: boolean;
  paysage: boolean;
  displayTotalAndPOR: boolean = true;
  displayVariante: boolean = false;
  displayNbPortionsParContenant: boolean = false;
  separateProduitComplementaire: boolean = false;
  startDate: Date = null;
  endDate: Date = null;

  subBonlivraison: Subscription;
  plcList: object[] = [];
  private subComment: Subscription;
  protected subPlc: Subscription;
  plcSelectedComment: string[] = [];
  plcSelectedMessage: string[] = [];
  plcSelectedFilter: string[] = [];

  constructor(
    private utils: UtilsService,
    private printMenuService: PrintMenuService,
    private pcSvc: PreparationConditionnementService) {
  }

  ngOnInit(): void {
    this.printMenuService.displayDialogPrintBonLivraison$.subscribe(payload => {
      this.planProductionIdList = payload?.planProductionIdList || [];
      this.planProductionDetailIdList = payload?.planProductionDetailIdList || [];
      this.initPlcList();
      this.displayDialog = true;
      this.paysage = false;
      this.separateProduitComplementaire = false;
    });
    this.initCommentaire();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subComment);
  }

  private initCommentaire = () => {
    this.subComment = this.printMenuService.getCommentaireBonlivraison().subscribe(response => {
      this.comment = response.replace(/^"(.*)"$/, '$1');
    });
  }

  downloadBonlivraison = (): void => {
    const printMode = this.paysage ? PRINT_MODE.PAYSAGE : PRINT_MODE.PORTRAIT;
    const bonLivraisonSettings: BonLivraisonSettingsMl = new BonLivraisonSettingsMl();
    bonLivraisonSettings.message = this.message;
    bonLivraisonSettings.comment = this.comment;
    bonLivraisonSettings.dateStart = this.startDate;
    bonLivraisonSettings.dateEnd = this.endDate;
    bonLivraisonSettings.plcMessageList = this.plcSelectedMessage.map(plcId => +plcId);
    bonLivraisonSettings.plcCommentList = this.plcSelectedComment.map(plcId => +plcId);
    bonLivraisonSettings.plcList = this.plcSelectedFilter.map(plcId => +plcId);
    bonLivraisonSettings.planProductionIdList = this.planProductionIdList;
    bonLivraisonSettings.planProductionDetailIdList = this.planProductionDetailIdList;
    bonLivraisonSettings.displayTotalAndPOR = this.displayTotalAndPOR;
    bonLivraisonSettings.displayNbPortionsParContenant = this.displayNbPortionsParContenant;
    bonLivraisonSettings.displayVariante = this.displayVariante;
    bonLivraisonSettings.separateProduitComplementaire = this.separateProduitComplementaire;

    this.displayDialog = false;
    this.loadingChange.emit({ visible: true, message: 'Impression en cours...' });
    this.pcSvc.printBonLivraison(bonLivraisonSettings, printMode)
      .pipe(finalize(() => this.loadingChange.emit({ visible: false, message: '' })))
      .subscribe();
  }

  closeDialog = () => {
    this.plcSelectedMessage = [];
    this.plcSelectedComment = [];
    this.plcSelectedFilter = [];
    this.plcList = [];
    this.displayDialog = false;
  };

  onChangePlcMessage(data: any) {
    this.plcSelectedMessage = data;
  }

  onChangePlcComment(data: any) {
    this.plcSelectedComment = data;
  }

  onChangePlcFilter(data: any) {
    this.plcSelectedFilter = data;
    this.plcSelectedComment = this.plcSelectedComment.filter(plcId => this.plcSelectedFilter.includes(plcId));
  }

  private initPlcList() {
    if (!this.planProductionIdList || this.planProductionIdList.length === 0) {
      this.plcList = [];
      this.plcSelectedComment = [];
      return;
    }
    this.subPlc = this.pcSvc.getPlcBonLivraison(this.planProductionIdList).subscribe(response => {
      this.plcList = response.resultList;
      this.plcSelectedComment = response.resultList.map(plc => plc.id);
      this.plcSelectedFilter = response.resultList.map(plc => plc.id);
    });
  }

  onValueChanged() {
    if (this.selectedDates.value[0] ) {
      const startDate = new Date(this.selectedDates.value[0]);
      startDate.setHours(0, 0, 0, 0);
      this.startDate = startDate;
    } else
      this.startDate = null;

    if (this.selectedDates.value[1]) {
      const endDate = new Date(this.selectedDates.value[1]);
      endDate.setHours(23, 59, 59, 999);
      this.endDate = endDate;
    } else
      this.endDate = null;
  }
}
